export default {"src":"/_next/static/media/icone-profile.a780252c.svg","height":34,"width":28,"blurWidth":0,"blurHeight":0};